package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
enum class AuthMethod(val channel: String) {
    EMAIL("email"), PHONE("sms")
}